import { LinearProgress } from "@/components/progress";
import { ProductEntity } from "../schema/products.schema";
import { NoData } from "@/components/common/section-components/NoData";
import { StandardTable } from "@/components/table/StandardTable";
import { Dispatch, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "@/constants/routes";
import { ProductActions } from "../components/ProductActions";

interface FertilizantesTableProps {
  loadingQuery: boolean;
  noActions: boolean;
  noSelection: boolean;
  setFertilizantesSelection: Dispatch<SetStateAction<string[]>>;
  sectionData: ProductEntity[] | undefined;
  fertilizantesSelection: string[];
}

const productsTableHeaderElements = [
  { label: "Nombre", value: "nombre", align: "inherit" },
  { label: "Descripción", value: "descripcion", align: "inherit" },
  //{ label: "Unidad de medida", value: "unidadMedida", align: "inherit" },
  { label: "Estado", value: "estadoTexto", align: "inherit" },
];

export const FertilizantesTable = ({
  loadingQuery,
  noActions,
  noSelection,
  setFertilizantesSelection,
  sectionData,
  fertilizantesSelection,
}: FertilizantesTableProps) => {
  const navigate = useNavigate();
  
  const handleEdit = (item: ProductEntity) => {
    navigate(AppRoutes.PRODUCTS_EDIT.replace(":id", String(item?.id)), { 
      state: { type: "fertilizante" } 
    });
  };

  const getActionElements = (item: ProductEntity) => (
    <ProductActions handleEdit={handleEdit} item={item} />
  );

  // Transformar los datos para incluir el texto del estado
  const transformedData = sectionData?.map(item => ({
    ...item,
    estadoTexto: item.activo ? "Activo" : "Desactivado"
  }));

  return loadingQuery ? (
    <LinearProgress />
  ) : (
    <>
      {!loadingQuery && Boolean(!sectionData?.length) ? (
        <NoData />
      ) : (
        <StandardTable
          headers={productsTableHeaderElements}
          items={transformedData || []}
          noActions={noActions}
          noSelection={noSelection}
          actionElements={getActionElements}
          actionsHeaderLabel="Edición"
          multipleSelection
          selection={fertilizantesSelection}
          setSelection={setFertilizantesSelection}
          noBorder
        />
      )}
    </>
  );
};
